import HtmlRender from "../../../components/Html/HtmlRender";
import { useParams, useNavigate } from "react-router-dom";
import { useEventLoader } from "../../../hooks/Events/useEventLoader";

export default function MemberSpecialEventTab() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const event = useEventLoader(id);

  if (!event) {
    return <div>Event not found</div>;
  }

  if (!event.specialEventTemplate) {
    return <div>No special event template found</div>;
  }

  const goToRegistration = () => {
    if (id) {
      navigate(`/events/${id}/registration`);
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).closest("a")) {
      return;
    }
    goToRegistration();
  };

  return (
    <div className="cursor-pointer" onClick={handleClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && goToRegistration()}>
      <HtmlRender htmlString={event.specialEventTemplate.template ?? ""} />
    </div>
  );
}
